import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import type {DepositPagoMovilPayload} from "./depositPagoMovil.schema";

export interface DepositPagoMovilApiPayload {
  referencia: string;
  importe: number;
  fecha: string;
  banco_origen: string;
}

export interface DepositPagoMovilResponse {
  data?: {
    status?: string;
    message?: string;
    reference?: string;
  };
  [key: string]: unknown;
}

const toApiPayload = (payload: DepositPagoMovilPayload): DepositPagoMovilApiPayload => ({
  referencia: payload.referencia,
  importe: payload.importe,
  fecha: payload.fecha,
  banco_origen: payload.banco_origen.startsWith("0") ? payload.banco_origen : `0${payload.banco_origen}`,
});

export const depositPagoMovilService = async (payload: DepositPagoMovilPayload): Promise<DepositPagoMovilResponse> => {
  return httpRequest<DepositPagoMovilResponse, DepositPagoMovilApiPayload>({
    method: "POST",
    url: "/user/pagomovil/bdv/consolidate",
    baseUrl: config.walletApiUrl,
    body: toApiPayload(payload),
  });
};
